import dayjs from 'dayjs';
import { NotificationDocument } from '@models/notification';

export const groupNotifications = (notifications: NotificationDocument[]) =>
  notifications.reduce(
    (acc, notification) => {
      const timestamp = notification.created;
      const date = dayjs(timestamp);
      const now = dayjs();

      const daysDifference = now.diff(date, 'day');

      if (daysDifference === 0) {
        acc.today.push(notification);
      } else if (daysDifference === 1) {
        acc.yesterday.push(notification);
      } else if (daysDifference >= 2 && daysDifference <= 7) {
        acc.lastWeek.push(notification);
      } else if (daysDifference >= 8) {
        acc.lastMonth.push(notification);
      }
      return acc;
    },
    {
      today: [] as NotificationDocument[],
      yesterday: [] as NotificationDocument[],
      lastWeek: [] as NotificationDocument[],
      lastMonth: [] as NotificationDocument[],
    }
  );
